import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import type { ProjectExample } from '../../data/projects';
interface TestimonialsSectionProps {
  title?: string;
  subtitle?: string;
  badgeText?: string;
  projects: ProjectExample[];
}

/**
 * Ejemplos reales de proyectos publicados. Cada tarjeta enlaza al sitio en
 * funcionamiento (nueva pestaña). No incluye citas, valoraciones ni métricas.
 */
export function TestimonialsSection({
  title = 'Negocios reales con su presencia digital resuelta',
  subtitle = 'Dos ejemplos en funcionamiento del tipo de web y carta digital que incluye el servicio. Pulsa en cada uno para visitar el sitio.',
  badgeText = 'Ejemplos',
  projects
}: TestimonialsSectionProps) {
  return <section id="testimonials" className="section-shell border-t border-white/10 bg-black" aria-labelledby="testimonials-title" data-id="element-184" data-mp="48mr26a7aao6">
      <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-185" data-mp="37q4xc9abr9mh">
        <div className="grid gap-7 border-b border-white/10 pb-10 lg:grid-cols-[0.8fr_1.2fr] lg:items-end" data-id="element-186" data-mp="37pv7clpa52gs">
          <div data-id="element-187" data-mp="3r817enoc8l7">
            <p className="eyebrow" data-id="element-188" data-mp="8sfaxj9dnhui">{badgeText}</p>
            <h2 id="testimonials-title" className="mt-5 text-3xl font-medium tracking-[-0.045em] text-white sm:text-4xl" data-id="element-189" data-mp="8r45lf0aa21a">
              {title}
            </h2>
          </div>
          <p className="max-w-2xl text-sm leading-relaxed text-neutral-300 sm:text-base" data-id="element-190" data-mp="hjxodmexvjjw">
            {subtitle}
          </p>
        </div>
        <div className="grid gap-5 pt-10 lg:grid-cols-2" data-id="element-191" data-mp="3lynq7i2yl51b">
          {projects.map(project => <a key={project.url} href={project.url} target="_blank" rel="noopener noreferrer" aria-label={`Visitar ${project.name} (${project.domain}), se abre en una pestaña nueva`} className="group flex flex-col border border-white/10 bg-[#0a0a0a] p-7 transition-colors duration-200 hover:border-white/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black sm:p-8" data-id="element-192" data-mp="3q0sgc6u77jj7">
              <div className="flex items-start justify-between gap-4 border-b border-white/10 pb-5" data-id="element-193" data-mp="32a60x6v9xar9">
                <div data-id="element-194" data-mp="3g9e4ebygz519">
                  <h3 className="text-xl font-medium tracking-[-0.03em] text-white sm:text-2xl" data-id="element-195" data-mp="3g8mgzof10dm2">
                    {project.name}
                  </h3>
                  <p className="mt-1.5 text-xs text-neutral-400" data-id="element-196" data-mp="2nl9wrkwc8hvx">
                    {project.sector}
                  </p>
                </div>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center border border-white/20 text-white transition-colors duration-200 group-hover:border-white group-hover:bg-white group-hover:text-black" data-id="element-197" data-mp="2ikvlltzfwrto">
                  <ArrowUpRightIcon size={16} aria-hidden="true" data-id="element-198" data-mp="24vjyuoxa3fzs" />
                </span>
              </div>
              <p className="mt-6 text-[15px] leading-relaxed text-neutral-200 sm:text-base" data-id="element-199" data-mp="1zwqk6t699iy1">
                {project.description}
              </p>
              <ul className="mt-6 flex flex-wrap gap-2" aria-label="Incluye" data-id="element-200" data-mp="fcv9zkxnms38">
                {project.scope.map(item => <li key={item} className="border border-white/15 px-3 py-1.5 text-xs text-neutral-300" data-id="element-201" data-mp="k6zhq6eqv45d">
                    {item}
                  </li>)}
              </ul>
              <p className="mt-auto flex items-center gap-2 pt-7 text-sm font-medium text-white" data-id="element-202" data-mp="y5z75ga2zn2l">
                <span className="underline decoration-white/30 underline-offset-4 transition-colors duration-200 group-hover:decoration-white" data-id="element-203" data-mp="132xyxs69vhxm">
                  {project.domain}
                </span>
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}